<template>
  <div
    class="screen-share-mask_wrap"
    :class="{
      'screen-share-mask_wrap_pause': remoteScreenShareInfo.status === 'pause',
    }"
  >
    <!-- 网页端 本地共享 -->
    <div
      class="local-screen-share-mask"
      v-if="screenShareStatus != 'end' && !isElectron"
    >
      <div class="tips">屏幕共享中</div>
      <div class="stop-btn" @click="handleStopShare">停止共享</div>
    </div>
    <!-- 拉流端展示 -->
    <div class="remote-share-wrap">
      <div
        v-show="showPullVideoStream"
        class="remote-share-box"
        ref="remoteShareBox"
      ></div>
      <!-- <div v-if="isLoadError" class="error-tips-box">
        <span class="text">{{ errorMsg }}</span>
        <div class="refresh-btn" @click="handleReload">刷新</div>
      </div> -->
      <div v-if="remoteScreenShareInfo.status === 'pause'" class="pause-box">
        老师已暂停屏幕共享
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import WebRTCPlayer from "@saas/components/src/utils/webrtc-player";
export default {
  props: {
    playUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isElectron: !!window.isElectron,
      currentScreenInfo: {},
      // CDN播放器相关
      cdnPlayer: null,
      isUsingCDN: false,
      isLoadError: false,
      errorMsg: "网络不稳定，建议检查网络设置或刷新直播间",
      showPlayButton: false,
    };
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "screenShareStatus",
      "remoteScreenShareInfo",
      "roomInfo",
      "userStatus",
      "isRecordPage",
    ]),
    showPullVideoStream() {
      // 快直播下台学生始终显示（用于 CDN 流播放）
      if (this.shouldUseCDN) {
        return true;
      }
      return this.remoteScreenShareInfo.status != "end";
    },
    // 判断是否应该使用CDN流
    shouldUseCDN() {
      // 快直播场景下
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        !this.isRecordPage
      ) {
        // 学生或助教上台（is_up_stage === 1）使用 TRTC，下台（is_up_stage === 2）使用 CDN
        return this.userStatus.is_up_stage === 2;
      }
      return false;
    },
  },
  watch: {
    liveService(val) {
      if (val) {
        this.handleLiveServiceListener();

        // 检查初始状态：如果学生初始进入时是下台状态，启动CDN播放器
        this.$nextTick(() => {
          if (this.shouldUseCDN && !this.isUsingCDN && this.playUrl) {
            uploadLiveLog({
              message: "liveService初始化后检查：需要启动CDN播放器",
              level: "info",
              tag: "lifecycle",
              extra: {
                component: "ScreenShare",
                action: "liveService_init_check",
                shouldUseCDN: this.shouldUseCDN,
                isUsingCDN: this.isUsingCDN,
                hasPlayUrl: !!this.playUrl,
              },
            });
            this.startCDNPlayer();
          }
        });
      }
    },
    // 监听上下台状态变化，触发流切换
    "userStatus.is_up_stage": {
      handler(val, oldVal) {
        // 只有快直播学生才需要处理
        if (
          this.roomInfo.is_quick_live === 1 &&
          (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
          !this.isRecordPage &&
          oldVal !== undefined
        ) {
          uploadLiveLog({
            message: "学生上下台状态变化，触发屏幕分享流切换",
            level: "info",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "is_up_stage_change",
              oldVal,
              newVal: val,
              shouldUseCDN: this.shouldUseCDN,
              screenShareStatus: this.remoteScreenShareInfo.status,
            },
          });

          if (val === 2 && oldVal === 1) {
            // 学生下台，切换到 CDN 流
            uploadLiveLog({
              message: "学生下台，切换到 CDN 流",
              level: "info",
              tag: "api",
              extra: {
                component: "ScreenShare",
                action: "downstage_switch_to_cdn",
                isUsingCDN: this.isUsingCDN,
              },
            });

            // 如果正在使用 TRTC 辅流，先停止
            if (
              !this.isUsingCDN &&
              this.liveService &&
              this.currentScreenInfo.userID
            ) {
              this.liveService.stopRemoteView({
                userID: this.currentScreenInfo.userID,
                streamType: 1,
              });
            }

            // 启动 CDN 播放器（如果还没启动）
            if (!this.isUsingCDN) {
              this.$nextTick(() => {
                this.startCDNPlayer();
              });
            }
          } else if (val === 1 && oldVal === 2) {
            // 学生上台，停止 CDN 播放器
            uploadLiveLog({
              message: "学生上台，停止 CDN 播放器",
              level: "info",
              tag: "api",
              extra: {
                component: "ScreenShare",
                action: "upstage_stop_cdn",
                isUsingCDN: this.isUsingCDN,
              },
            });
            this.showPlayButton = false; // 重置播放按钮状态
            if (this.isUsingCDN) {
              // 停止 CDN 播放器
              this.stopCDNPlayer().then(() => {
                // 如果老师正在分享，启动 TRTC 辅流
                if (
                  this.remoteScreenShareInfo.status === "start" &&
                  this.liveService &&
                  this.currentScreenInfo.userID
                ) {
                  this.$nextTick(() => {
                    this.liveService.startRemoteSubView({
                      userID: this.currentScreenInfo.userID,
                      view: this.$refs.remoteShareBox,
                    });
                  });
                }
              });
            }
          }
        }
      },
    },
    // 监听播放按钮状态变化，通知父组件
    showPlayButton: {
      handler(val) {
        this.$emit('update:showPlayButton', val);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", [
      "setScreenShareStatus",
      "setRemoteScreenShareInfo",
      "setShowCdnStreamError",
    ]),
    handlePlayClick() {
      // 只有在使用CDN且播放器存在时才处理
      if (this.cdnPlayer && this.showPlayButton && this.shouldUseCDN) {
        // 先隐藏按钮，避免重复点击
        this.showPlayButton = false;
        
        // blocked 后已经在静音播放，点击按钮取消静音
        this.cdnPlayer.unmute().then(() => {
          console.log("[ScreenShare] 用户点击取消静音成功");
          uploadLiveLog({
            message: "用户点击取消静音按钮-成功",
            level: "info",
            extra: {
              component: "ScreenShare",
              action: "click_unmute_button_success",
            },
          });
        }).catch((error) => {
          console.error("[ScreenShare] 用户点击取消静音失败:", error);
          // 失败后重新显示按钮（仅当仍应使用CDN时）
          if (this.shouldUseCDN) {
            this.showPlayButton = true;
          }
          uploadLiveLog({
            message: "用户点击取消静音按钮-失败",
            level: "error",
            extra: {
              component: "ScreenShare",
              action: "click_unmute_button_failed",
              error: error?.message || String(error),
            },
          });
        });
        
        uploadLiveLog({
          message: "用户点击取消静音按钮",
          level: "info",
          extra: {
            component: "ScreenShare",
            action: "click_unmute_button",
          },
        });
      }
    },
    handleReload() {
      window.location.reload();
      uploadLiveLog({
        message: "用户点击刷新",
        extra: {
          component: "ScreenShare",
          action: "click_screen_share_reload",
        },
      });
    },
    handleStopShare() {
      uploadLiveLog({
        message: "用户点击停止共享",
        extra: {
          component: "ScreenShare",
          action: "click_screen_share_stop",
          screenShareStatus: this.screenShareStatus,
          isElectron: this.isElectron,
        },
      });

      // 停止共享
      this.liveService.stopScreenCapture();
      this.setScreenShareStatus("end");
    },
    handleLiveServiceListener() {
      this.liveService.on(
        "userSubStreamAvailable",
        this.onUserSubStreamAvailable
      );
    },
    onUserSubStreamAvailable(res) {
      console.log("获取共享数据流", res);
      uploadLiveLog({
        message: "远端用户屏幕共享数据流变化",
        extra: {
          component: "ScreenShare",
          action: "onUserSubStreamAvailable",
          res: res,
        },
      });
      if (res.available === 1) {
        this.isRecivingShare = true;
        this.currentScreenInfo = res;
        this.setRemoteScreenShareInfo({
          status: "start",
        });

        // 判断是否使用CDN流
        if (this.shouldUseCDN) {
          uploadLiveLog({
            message: "学生在快直播中，使用CDN流订阅屏幕分享",
            level: "info",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "onUserSubStreamAvailable",
              shouldUseCDN: this.shouldUseCDN,
              isUsingCDN: this.isUsingCDN,
            },
          });
          // 如果 CDN 播放器还没启动，则启动它
          if (!this.isUsingCDN) {
            this.$nextTick(() => {
              this.startCDNPlayer();
            });
          } else {
            uploadLiveLog({
              message: "CDN播放器已启动，无需重复启动",
              level: "info",
              tag: "api",
              extra: {
                component: "ScreenShare",
                action: "onUserSubStreamAvailable",
              },
            });
          }
        } else {
          uploadLiveLog({
            message: "使用TRTC流订阅屏幕分享",
            level: "info",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "onUserSubStreamAvailable",
              shouldUseCDN: this.shouldUseCDN,
            },
          });
          this.$nextTick(() => {
            this.liveService.startRemoteSubView({
              userID: res.userID,
              view: this.$refs.remoteShareBox,
            });
          });
        }
      } else {
        if (this.currentScreenInfo.userID === res.userID) {
          this.isRecivingShare = false;
          this.setRemoteScreenShareInfo({
            status: "end",
          });
          // 如果学生是下台状态，不停止CDN播放器（继续播放等待老师下次分享）
          if (
            this.isUsingCDN &&
            !(
              this.roomInfo.is_quick_live === 1 &&
              this.roomInfo.isStudent &&
              this.userStatus.is_up_stage === 2
            )
          ) {
            this.stopCDNPlayer();
          }
        }
      }
      this.$emit("updateShareStatus", this.isRecivingShare);
    },
    // 启动CDN播放器
    async startCDNPlayer() {
      // 重置错误状态
      this.isLoadError = false;

      // 如果已经有播放器实例，先销毁旧的，防止重复创建
      if (this.cdnPlayer) {
        uploadLiveLog({
          message: "检测到已存在的CDN播放器，先销毁旧的播放器",
          level: "warn",
          tag: "api",
          extra: {
            component: "ScreenShare",
            action: "startCDNPlayer",
            isUsingCDN: this.isUsingCDN,
          },
        });
        try {
          this.cdnPlayer.destroy();
          this.cdnPlayer = null;
        } catch (e) {
          console.error("销毁旧播放器失败:", e);
        }
      }

      if (this.isUsingCDN) {
        uploadLiveLog({
          message: "CDN播放器已启动，跳过重复启动",
          level: "info",
          tag: "api",
          extra: {
            component: "ScreenShare",
            action: "startCDNPlayer",
          },
        });
        return Promise.resolve();
      }

      try {
        // 从 props 中获取 play_url
        const cdnUrl = this.playUrl;

        if (!cdnUrl) {
          uploadLiveLog({
            message: "playUrl未传入，无法启动CDN播放器",
            level: "error",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "startCDNPlayer",
            },
          });
          return Promise.reject(new Error("playUrl未传入，无法启动CDN播放器"));
        }

        // 立即设置标志位，防止并发调用
        this.isUsingCDN = true;

        uploadLiveLog({
          message: "开始启动CDN播放器",
          level: "info",
          tag: "api",
          extra: {
            component: "ScreenShare",
            action: "startCDNPlayer",
            cdnUrl: cdnUrl,
          },
        });

        this.cdnPlayer = new WebRTCPlayer({
          container: this.$refs.remoteShareBox,
          url: cdnUrl,
          onError: (errorMsg) => {
            this.errorMsg = errorMsg;
            this.isLoadError = true;
            this.setShowCdnStreamError({
              visible: true,
              info: {
                errorMessage: errorMsg,
              },
            });
          },
          onPlaying: () => {
            this.isLoadError = false;
            this.showPlayButton = false; // 开始播放后隐藏播放按钮
          },
          onNeedUserInteraction: () => {
            this.showPlayButton = true; // blocked 后需要用户交互
            uploadLiveLog({
              message: "CDN播放器需要用户交互",
              level: "warn",
              extra: {
                component: "ScreenShare",
                action: "need_user_interaction",
              },
            });
          },
        });

        return this.cdnPlayer
          .init()
          .then(() => {
            uploadLiveLog({
              message: "CDN播放器启动成功",
              level: "info",
              tag: "api",
              extra: {
                component: "ScreenShare",
                action: "startCDNPlayer",
              },
            });
          })
          .catch((error) => {
            // 启动失败时重置标志位
            this.isUsingCDN = false;
            this.cdnPlayer = null;
            this.showPlayButton = false; // 重置播放按钮状态
            uploadLiveLog({
              message: "CDN播放器启动失败",
              level: "error",
              tag: "api",
              extra: {
                component: "ScreenShare",
                action: "startCDNPlayer",
                error: error?.message || error,
              },
            });
            throw error;
          });
      } catch (error) {
        // 异常时重置标志位
        this.isUsingCDN = false;
        this.cdnPlayer = null;
        this.showPlayButton = false; // 重置播放按钮状态
        uploadLiveLog({
          message: "CDN播放器创建失败",
          level: "error",
          tag: "api",
          extra: {
            component: "ScreenShare",
            action: "startCDNPlayer",
            error: error?.message || error,
          },
        });
        return Promise.reject(error);
      }
    },
    // 停止CDN播放器
    stopCDNPlayer() {
      if (!this.cdnPlayer || !this.isUsingCDN) {
        // 即使播放器不存在，也要重置播放按钮状态
        this.showPlayButton = false;
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        try {
          uploadLiveLog({
            message: "停止CDN播放器",
            level: "info",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "stopCDNPlayer",
            },
          });

          this.cdnPlayer
            .stop()
            .then(() => {
              // 停止后立即销毁播放器，彻底释放资源
              this.cdnPlayer.destroy();
              this.cdnPlayer = null;
              this.isUsingCDN = false;
              this.showPlayButton = false; // 重置播放按钮状态
              uploadLiveLog({
                message: "CDN播放器停止并销毁成功",
                level: "info",
                tag: "api",
                extra: {
                  component: "ScreenShare",
                  action: "stopCDNPlayer",
                },
              });
              resolve();
            })
            .catch((error) => {
              // 即使停止失败，也尝试销毁播放器
              if (this.cdnPlayer) {
                this.cdnPlayer.destroy();
                this.cdnPlayer = null;
              }
              this.isUsingCDN = false;
              this.showPlayButton = false; // 重置播放按钮状态
              uploadLiveLog({
                message: "CDN播放器停止失败，已强制销毁",
                level: "error",
                tag: "api",
                extra: {
                  component: "ScreenShare",
                  action: "stopCDNPlayer",
                  error: error?.message || error,
                },
              });
              resolve();
            });
        } catch (error) {
          // 异常情况下也要确保播放器被销毁
          if (this.cdnPlayer) {
            try {
              this.cdnPlayer.destroy();
            } catch (e) {
              console.error("销毁播放器异常:", e);
            }
            this.cdnPlayer = null;
          }
          this.isUsingCDN = false;
          this.showPlayButton = false; // 重置播放按钮状态
          uploadLiveLog({
            message: "CDN播放器停止异常，已强制销毁",
            level: "error",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "stopCDNPlayer",
              error: error?.message || error,
            },
          });
          resolve();
        }
      });
    },
    // 销毁CDN播放器
    destroyCDNPlayer() {
      if (this.cdnPlayer) {
        try {
          uploadLiveLog({
            message: "销毁CDN播放器",
            level: "info",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "destroyCDNPlayer",
            },
          });
          this.cdnPlayer.destroy();
          this.cdnPlayer = null;
          this.isUsingCDN = false;
          this.showPlayButton = false; // 重置播放按钮状态
        } catch (error) {
          this.cdnPlayer = null;
          this.isUsingCDN = false;
          this.showPlayButton = false; // 重置播放按钮状态
          uploadLiveLog({
            message: "销毁CDN播放器失败",
            level: "error",
            tag: "api",
            extra: {
              component: "ScreenShare",
              action: "destroyCDNPlayer",
              error: error?.message || error,
            },
          });
        }
      }
    },
    // 处理流切换（上下台切换）
    handleStreamSwitch() {
      uploadLiveLog({
        message: "处理屏幕分享流切换",
        level: "info",
        tag: "api",
        extra: {
          component: "ScreenShare",
          action: "handleStreamSwitch",
          shouldUseCDN: this.shouldUseCDN,
          isUsingCDN: this.isUsingCDN,
          is_up_stage: this.userStatus.is_up_stage,
        },
      });
      if (this.shouldUseCDN && !this.isUsingCDN) {
        // 需要切换到 CDN 流（下台）
        uploadLiveLog({
          message: "学生下台，从 TRTC 切换到 CDN 流",
          level: "info",
          tag: "api",
          extra: {
            component: "ScreenShare",
            action: "switchToCDN",
          },
        });

        // 停止 TRTC 辅流
        if (this.liveService && this.currentScreenInfo.userID) {
          this.liveService.stopRemoteView({
            userID: this.currentScreenInfo.userID,
            streamType: 1,
          });
        }

        // 启动 CDN 播放器
        this.$nextTick(() => {
          this.startCDNPlayer();
        });
      } else if (!this.shouldUseCDN && this.isUsingCDN) {
        // 需要切换到 TRTC 流（上台）
        uploadLiveLog({
          message: "学生上台，从 CDN 切换到 TRTC 流",
          level: "info",
          tag: "api",
          extra: {
            component: "ScreenShare",
            action: "switchToTRTC",
          },
        });

        // 停止 CDN 播放器
        this.stopCDNPlayer().then(() => {
          // 启动 TRTC 辅流
          if (this.liveService && this.currentScreenInfo.userID) {
            this.$nextTick(() => {
              this.liveService.startRemoteSubView({
                userID: this.currentScreenInfo.userID,
                view: this.$refs.remoteShareBox,
              });
            });
          }
        });
      }
    },
  },
  mounted() {
    uploadLiveLog({
      message: "ScreenShare组件挂载",
      level: "info",
      tag: "lifecycle",
      extra: {
        component: "ScreenShare",
        shouldUseCDN: this.shouldUseCDN,
        remoteScreenShareStatus: this.remoteScreenShareInfo?.status,
        isUsingCDN: this.isUsingCDN,
        hasPlayUrl: !!this.playUrl,
      },
    });
  },
  beforeDestroy() {
    // 销毁CDN播放器
    this.destroyCDNPlayer();
  },
};
</script>

<style lang="scss" scoped>
.screen-share-mask_wrap {
  z-index: 99;
  .local-screen-share-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(29, 33, 41, 0.4);
    backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tips {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 24px;
    }
    .stop-btn {
      width: 84px;
      height: 36px;
      background: #cb2634;
      border-radius: 12px 12px 12px 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #f7f8fa;
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .remote-share-wrap {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    .remote-share-box {
      width: 100%;
      height: 100%;
    }
    .pause-box {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 970;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      background: rgba(29, 33, 41, 0.4);
      backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
    }
    .error-tips-box {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #ffffff;
      border: 1px solid #e5e6eb;
      border-radius: 2px;
      padding: 9px 16px;
      z-index: 970;
      display: flex;
      align-items: center;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

      .text {
        font-size: 14px;
        color: #1d2129;
        margin-right: 12px;
        white-space: nowrap;
      }

      .refresh-btn {
        cursor: pointer;
        color: #165dff;
        border: 1px solid #165dff;
        padding: 4px 15px;
        border-radius: 2px;
        font-size: 12px;
        line-height: 20px;
        transition: all 0.3s;

        &:hover {
          background: #e8f3ff;
        }
      }
    }
  }
}
.screen-share-mask_wrap_pause {
  z-index: unset;
}
</style>
